module.exports = __webpack_public_path__ + "static/media/BrutalType-Medium.5f601a4c.woff2";